<template>
  <div class="home-page">
    <MotPopUp :show="showPopup">
      <div class="sound-icon">
        <img src="@/assets/images/sound.gif" alt="Sound">
      </div>
      <MotHeading level="h3" color="white" weight="bolder">Let's turn on the sound!</MotHeading>
      <MotText color="white">For total immersion, we recommend that you turn on the sound</MotText>
      <br>
      <MotButton color="white" @click="startVideoWithSound">Turn on</MotButton>
    </MotPopUp>
    <video
      playsinline
      preload="none"
      autoplay
      :muted="!sound"
      id="Video"
      @ended="onVideoEnded"
      @timeupdate="onTimeUpdateListener"
    >
      <source src="@/assets/video/video-background-3.mp4" type="video/mp4" />
    </video>

    <div class="home-page__wrapper">
      <div class="home-page__header">
        <div class="home-page__header-logo-wrapper">
          <a href="/"><MotLogo class="home-page__header-logo" name="full-white"></MotLogo></a>
          <MotText tag="div" color="white" class="home-page__header-text">
            {{ textHeaderLogo }}
          </MotText>
        </div>


        <div class="home-page__header-buttons-wrapper">
          <MotButton
            v-if="playing"
            key="pause-button"
            class="home-page__header-button"
            icon-left="pause"
            color="white"
            @click="togglePlaying"
            outlined
          ></MotButton>

          <MotButton
            v-if="!playing"
            key="playing-button"
            class="home-page__header-button"
            icon-left="play"
            color="white"
            @click="togglePlaying"
            outlined
          ></MotButton>

          <MotButton
            v-if="!sound && !fullVideo"
            key="enable-sound-button"
            class="home-page__header-button"
            icon-left="muted-full"
            color="white"
            @click="toggleSound"
            outlined
          ></MotButton>

          <MotButton
            v-if="sound && !fullVideo"
            key="disable-sound-button"
            class="home-page__header-button"
            icon-left="speaker"
            color="white"
            @click="toggleSound"
            outlined
          ></MotButton>

          <MotLink
            v-if="!fullVideo"
            key="play-button"
            class="home-page__header-button"
            icon-left="play"
            color="white"
            @click="toggleVideo"
            outlined
            >{{ textWatchFullVideo }}
          </MotLink>

          <MotLink
            v-if="fullVideo"
            key="close-button"
            class="home-page__header-button"
            icon-left="close"
            color="white"
            @click="toggleVideo"
            outlined
            >{{ textBackVideo }}
          </MotLink>
        </div>
      </div>

      <transition name="slide-fade">
        <div class="home-page__body" v-if="!fullVideo">
          <div class="container">
            <Animated
              enter="animate__backInLeft"
              leave="animate__backOutRight"
              :duration="{ enter: 1800, leave: 1000 }"
            >
              <div
                class="home-page__body-step home-page__body-step-one "
                v-if="mode === 'STEP_1' || mode === 'STEP_2'"
              >
                <MotHeading
                  level="h2"
                  weight="bolder"
                  color="white"
                  class="home-page__body-header"
                  >{{ textStepOneHeader }}
                </MotHeading>
                <Animated
                  enter="animate__backInLeft"
                  leave="animate__backOutRight"
                  :duration="{ enter: 1800, leave: 1000 }"
                >
                  <div class="" v-if="mode === 'STEP_2'">
                    <MotHeading
                      level="h2"
                      weight="bolder"
                      color="white"
                      class="home-page__body-header"
                      >{{ textStepOneSecondHeader }}
                    </MotHeading>
                    <MotButton
                      class="home-page__body-button"
                      @click="toggleMode('STEP_4')"
                      >{{ textJoinUs }}</MotButton
                    >
                    <!-- <MotLink 
                      link="https://blog.motorooms.com/"
                      color="white" 
                      class="home-page__body-link-blog link-blog">
                      {{ textBlog }}
                      <svg width="30" height="11" viewBox="0 0 30 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M24.8187 10.227C24.6681 10.2273 24.5457 10.107 24.5455 9.95827C24.5453 9.88658 24.5742 9.8178 24.6256 9.76717L29.342 5.11161L24.6256 0.456031C24.5209 0.349086 24.524 0.178636 24.6323 0.0753263C24.738 -0.0254343 24.9055 -0.0254343 25.0112 0.0753263L29.9202 4.92153C30.0266 5.02665 30.0266 5.19708 29.9202 5.30223L25.0112 10.1484C24.9601 10.1988 24.8909 10.227 24.8187 10.227Z" fill="white"/>
                        <path d="M29.7301 5.4543H0.269894C0.120841 5.4543 0 5.30169 0 5.11341C0 4.92513 0.120841 4.77248 0.269894 4.77248H29.7301C29.8792 4.77248 30 4.92513 30 5.11341C30 5.30169 29.8791 5.4543 29.7301 5.4543Z" fill="white"/>
                      </svg>
                    </MotLink> -->
                  </div>
                </Animated>
              </div>
            </Animated>

            <Animated
              enter="animate__backInLeft"
              leave="animate__backOutRight"
              :duration="{ enter: 1800, leave: 1000 }"
            >
              <div
                class="home-page__body-step home-page__body-step-two"
                v-if="mode === 'STEP_3'"
              >
                <MotHeading
                  level="h5"
                  weight="bold"
                  color="white"
                  class="home-page__body-heading"
                  >{{ textStepTwoHeading }}
                </MotHeading>

                <MotHeading
                  level="h2"
                  weight="bolder"
                  color="white"
                  class="home-page__body-header"
                  >{{ textStepTwoHeader1 }}
                </MotHeading>

                <MotHeading
                  level="h2"
                  weight="bolder"
                  color="white"
                  class="home-page__body-header"
                  >{{ textStepTwoHeader2 }}
                </MotHeading>

                <MotText tag="div" color="white" class="home-page__body-text">{{
                  textStepTwoText
                }}</MotText>
                <MotText tag="div" color="white" class="home-page__body-text">{{
                  textStepTwoText2
                }}</MotText>
                <MotButton
                  class="home-page__body-button"
                  @click="toggleMode('STEP_4')"
                  >{{ textLetsDoThis }}</MotButton
                >
              </div>
            </Animated>
            <Animated
              enter="animate__backInLeft"
              leave="animate__backOutRight"
              :duration="{ enter: 1800, leave: 1800 }"
            >
              <div
                class="home-page__body-step home-page__body-step-three"
                v-show="mode === 'STEP_4'"
              >
                <MotButton
                  key="close-button"
                  class="home-page__close-button"
                  icon-left="close"
                  color="white"
                  @click="closeForm"
                ></MotButton>

                <div class="mot-home-page__body-step-three-form">
                  <form @submit.prevent="onJoinUs">
                    <MotHeading
                      level="h2"
                      color="brand-blue"
                      class="form-heading"
                      weight="bolder"
                      >{{ textStepThreeHeader }}
                    </MotHeading>

                    <MotText
                      color="black"
                      class="home-page__body-form-heading first-heading"
                      >{{ textStepThreeText }}
                    </MotText>
                    <MotText
                      color="black"
                      class="home-page__body-form-heading second-heading"
                      >{{ textStepThreeText2 }}
                    </MotText>

                    <div class="home-page__body-form-inputs first-name">
                      <MotInputLined
                        label="First name*"
                        type="text"
                        width="expanded"
                        key="firstname"
                        :error="errors.firstname"
                        @change="updateFirstName"
                        required
                      />
                    </div>

                    <div class="home-page__body-form-inputs">
                      <MotInputLined
                        label="Email address*"
                        type="text"
                        width="expanded"
                        key="email"
                        :error="errors.email"
                        @change="updateEmail"
                      />
                    </div>

                    <div
                      class="home-page__body-form-inputs home-page__body-form-inputs-flex"
                    >
                      <MotInputLined
                        class="country"
                        label="Country*"
                        type="text"
                        width="expanded"
                        :error="errors.country"
                        @change="updateCountry"
                      />

                      <MotInputLined
                        class="zipcode"
                        label="Post code / Zip"
                        type="text"
                        width="expanded"
                        @change="updateZipcode"
                      />
                    </div>
                    <div>
                      <MotCheckbox
                        color="brand-orange"
                        size="l"
                        :value.sync="readytohost"
                        expanded
                      >
                        Motorooms founder, Bill, rides the world connecting with
                        other riders and those intrigued by this project and the
                        rider lifestyle. If you would be interested in hosting
                        him if he is in your area, please click here.
                      </MotCheckbox>
                    </div>
                    <input
                      name="phone"
                      type="text"
                      v-model="check"
                      style="display:none"
                    />
                    <MotNotification
                      color="danger"
                      icon-name="deprecated"
                      v-if="errors.message"
                    >
                      {{ errors.message }}
                    </MotNotification>
                    <div class="home-page__body-form-row">
                      <MotButton color="brand-orange" expanded submit
                        >{{ textStepThreeButton }}
                      </MotButton>
                    </div>
                  </form>
                  <b-loading
                    :active="loading"
                    :is-full-page="false"
                  ></b-loading>
                </div>
              </div>
            </Animated>
            <Animated
              enter="animate__backInLeft"
              leave="animate__backOutRight"
              :duration="{ enter: 1800, leave: 1800 }"
            >
              <div
                class="home-page__body-step home-page__body-step-four"
                v-if="mode === 'STEP_5'"
              >
                <MotHeading
                  level="h5"
                  weight="bold"
                  color="white"
                  class="home-page__body-heading"
                  >{{ textStepFourHeading }}
                </MotHeading>

                <MotHeading
                  level="h2"
                  weight="bolder"
                  color="white"
                  class="home-page__body-header"
                  >{{ textStepFourHeader1 }}
                </MotHeading>

                <MotHeading
                  level="h2"
                  weight="bolder"
                  color="white"
                  class="home-page__body-header"
                  >{{ textStepFourHeader2 }}
                </MotHeading>
              </div>
            </Animated>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "Index",
  props: {
    videoBackground: {
      type: String,
      default: "assets/video/video-background.mp4",
    },
    textHeaderLogo: {
      type: String,
      default: "Ride your path",
    },
    textWatchFullVideo: {
      type: String,
      default: "Full video",
    },
    textBackVideo: {
      type: String,
      default: "Go back",
    },
    textStepOneHeader: {
      type: String,
      default: "We’re building a brand new world...",
    },
    textStepOneSecondHeader: {
      type: String,
      default: "One built by riders, for riders.",
    },
    textStepTwoHeading: {
      type: String,
      default: "Help create the world you want to ride in.",
    },
    textStepTwoHeader1: {
      type: String,
      default: "Inspired?",
    },
    textStepTwoHeader2: {
      type: String,
      default: "Leave us your email.",
    },
    textStepTwoText: {
      type: String,
      default: "We'll be in touch with launch news and opportunities.",
    },
    textStepTwoText2: {
      type: String,
      default: "(Don't worry, we hate spam too.)",
    },
    textStepThreeHeader: {
      type: String,
      default: "Tell me more",
    },
    textStepThreeText: {
      type: String,
      default:
        "We are creating new ways for riders to meet and connect. We welcome you to our community of passionate riders.",
    },
    textStepThreeText2: {
      type: String,
      default: "More information about our project to come, there will be special opportunities for early sign ups",
    },
    textStepThreeButton: {
      type: String,
      default: "Join us",
    },
    textStepFourHeading: {
      type: String,
      default: "We will keep you posted.",
    },
    textStepFourHeader1: {
      type: String,
      default: "Thank you for joining",
    },
    textStepFourHeader2: {
      type: String,
      default: "our riders family.",
    },
    textJoinUs: {
      type: String,
      default: "Learn More",
    },
    textBlog: {
      type: String,
      default: "Visit our blog",
    },
    textLetsDoThis: {
      type: String,
      default: "Let's do this",
    },
  },
  data() {
    return {
      firstname: "",
      email: "",
      country: "",
      zipcode: "",
      check: "",
      readytohost: false,
      loading: false,
      showPopup: false,
      errors: {
        firstname: this.errorFirstName,
        email: this.errorEmail,
        country: this.errorCountry,
        zipcode: this.errorZipCode,
        message: "",
      },
      mode: "STEP_0",
      previous: "STEP_1",
      fullVideo: false,
      sound: false,
      playing: true,
    };
  },
  watch: {
    errorFirstName(newValue) {
      this.errors.firstname = newValue;
    },
    errorEmail(newValue) {
      this.errors.email = newValue;
    },
    errorCountry(newValue) {
      this.errors.country = newValue;
    },
    errorZipCode(newValue) {
      this.errors.zipcode = newValue;
    },
  },
  methods: {
    clearErrors() {
      this.errors.firstname = "";
      this.errors.email = "";
      this.errors.country = "";
      this.errors.zipcode = "";
      this.errors.message = "";
    },
    updateFirstName(value) {
      this.firstname = value;
    },
    updateEmail(value) {
      this.email = value;
    },
    updateCountry(value) {
      this.country = value;
    },
    updateZipcode(value) {
      this.zipcode = value;
    },
    toggleMode(step) {
      this.previous = this.mode;
      this.mode = step;
    },
    toggleVideo() {
      this.fullVideo = !this.fullVideo;
      if (document && this.fullVideo) {
        document.getElementById("Video").muted = false;
      }
      if (!this.fullVideo) {
        document.getElementById("Video").muted = !this.sound;
      }
    },
    toggleSound() {
      this.sound = !this.sound;
    },
    startVideoWithSound() {
      this.showPopup = false;
      this.sound = true;
      document.getElementById("Video").currentTime = 0
      document.getElementById("Video").play()
    },
    togglePlaying() {
      let video = document.getElementById("Video");
      if (document && video.currentTime === video.duration) {
        video.currentTime = 0;
        this.toggleMode("STEP_1");
        this.start();
      }
      this.playing = !this.playing;
      if (document && this.playing) {
        video.play();
      }
      if (!this.playing) {
        video.pause();
      }
    },
    closeForm() {
      if (this.previous) {
        this.toggleMode(this.previous);
      } else {
        this.toggleMode("STEP_2");
      }
    },
    onVideoEnded() {
      let video = document.getElementById("Video");
      video.pause();
      this.toggleMode("STEP_4");
      this.playing = !this.playing;
      this.fullVideo = false;
    },
    onJoinUs() {
      this.clearErrors();
      this.loading = true;
      axios
        .post(process.env.VUE_APP_API_URL + "user", {
          firstname: this.firstname,
          email: this.email,
          country: this.country,
          zip: this.zipcode,
          check: this.check,
          readytohost: this.readytohost,
        })
        .then(() => {
          this.loading = false;
          this.toggleMode("STEP_5");
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.data.errors) {
            this.errorsHandler(error.response.data.errors);
          } else {
            this.errors.message = "Something went wrong...";
          }
        });
    },
    errorsHandler(errors) {
      if (errors.length < 1) {
        return;
      }
      errors.forEach((error) => {
        switch (error.title) {
          case "EMAIL_EXISTS":
          case "EMPTY_EMAIL":
          case "INVALID_EMAIL":
            this.errors.email = error.detail;
            break;
          case "EMPTY_FIRSTNAME":
            this.errors.firstname = error.detail;
            break;
          case "EMPTY_COUNTRY":
            this.errors.country = error.detail;
            break;
        }
      });
    },
    start() {
      setTimeout(() => {
        if (!this.sound) {
          document.getElementById("Video").pause();
          document.getElementById("Video").volume = 1
          this.showPopup = true
        }
      }, 3000);
    },
    onTimeUpdateListener() {
      if (
        document.getElementById("Video").currentTime > 12.5 &&
        document.getElementById("Video").currentTime < 30
      ) {
        if (this.mode === "STEP_1") {
          this.toggleMode("STEP_2");
        }
      }
      if (document.getElementById("Video").currentTime > 30) {
        if (this.mode === "STEP_2") {
          this.toggleMode("STEP_3");
        }
      }
    },
  },
  mounted() {
    this.start();
    if (this.mode === "STEP_0") {
      this.toggleMode("STEP_1");
    }
  },
};
</script>
